// Cụm nút thao tác ký (Ký duyệt / Xin ý kiến / Y/c bổ sung / Trả về / Hủy) — markup như V1.
import React from "react";
import Spinner from "../../component/Spinner";

export default function SignActionButtons({
  currentUserStep,
  group,
  detail,
  userComment,
  setUserComment,
  buttonLoading,
  handleApprove,
  handleApproveQues,
  handleRequestUpdate,
  giveBack,
  handleReject,
  addMember,
}) {
  return (
    <>
      <div className="mt-2">
        <textarea
          className="form-control mb-2"
          placeholder="Nêu ý kiến..."
          value={userComment}
          onKeyDown={(e) => {
            if (e.key === "Enter" && !e.shiftKey) e.preventDefault();
          }}
          onChange={(e) => setUserComment(e.target.value)}
        />
        <div className="row">
          <div className="col-6 mt-2">
            <button type="button" className="btn w-100 btn-success btn-sm me-2" onClick={() => handleApprove(currentUserStep.id)} disabled={buttonLoading}>
              <i className="fas fa-check"></i> Ký duyệt
            </button>
          </div>
          <div className="col-6 mt-2">
            <button type="button" className="btn w-100 btn-secondary btn-sm me-2" onClick={() => handleApproveQues(currentUserStep.id)} disabled={buttonLoading}>
              <i className="far fa-question-circle"></i> Xin ý kiến
            </button>
          </div>
          <div className="col-6 mt-2">
            <button type="button" className="btn w-100 btn-info text-white btn-sm me-2" onClick={() => handleRequestUpdate(currentUserStep.id)} disabled={buttonLoading}>
              <i className="fas fa-edit"></i> Y/c bổ sung
            </button>
          </div>
          <div className="col-6 mt-2">
            <button type="button" className="btn w-100 btn-warning text-white btn-sm me-2" onClick={() => giveBack(currentUserStep.id)} disabled={buttonLoading}>
              <i className="fas fa-undo"></i> Trả về
            </button>
          </div>
          <div className="col-6 mt-2">
            <button type="button" className="w-100 btn btn-danger btn-sm" onClick={() => handleReject(currentUserStep.id)} disabled={buttonLoading}>
              <i className="fas fa-times"></i> Hủy bỏ
            </button>
          </div>
          {buttonLoading ? <Spinner /> : ""}
        </div>
      </div>
      {detail.position != 0 && (
        <div className="w-100 mt-2">
          <button
            type="button"
            className="w-100 btn btn-sm btn-primary"
            onClick={() => addMember(currentUserStep.position, group.group_name)}
          >
            <span className="fas fa-user-plus"></span> Thêm người ký
          </button>
        </div>
      )}
    </>
  );
}
